import { InjectionToken } from '@angular/core';

export enum EntityStoreKey {
  featureFlags = 'featureFlags',
}

export type FeatureFlagsMap = Record<FeatureFlag, boolean>;
export const FEATURE_FLAGS = new InjectionToken<FeatureFlagsMap>('Feature flags map');

export enum FeatureFlag {
  DisableZiggeo = 'disable-ziggeo',
  Referrals = 'referrals', // This flag should be migrated to pricing features after release
  EventDebug = 'debug_event_tracking',
  Hotjar = 'hotjar',
  Texting = 'texting',
  SharedMailbox = 'shared_mailbox',
  NewTalentPools = 'new_talent_pools',
  RenewalDowngrade = 'renewal_downgrade',
  Marketplace = 'marketplace',
  AccessToCandidate = 'access_to_candidate',
  BlockAdminsWithoutAccess = 'block_admins_without_access',
  JobCoverImage = 'job_cover_image',
}
